import React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import CardMedia from '@mui/material/CardMedia';
import { Typography } from '../../Typography';
import { ClubRTagCashbackLabel } from '../../Label';
import { getCardPartnerStyles } from './CardPartner.style';
export const CardPartner = ({ variant, cashBack, banner, logo, alt, backgroundColor, category, content }) => {
    const styles = getCardPartnerStyles(variant, backgroundColor);
    return (React.createElement(Box, { sx: styles.container },
        React.createElement(Stack, { "data-qa": "card-Partner-core" },
            React.createElement(Stack, { sx: styles.logoContainer }, ['LogoOnly', 'LogoCard'].includes(variant) ? (
            /* Affihage du logo en banner */
            React.createElement(CardMedia, { sx: styles.logo, component: "img", image: logo, alt: alt })) : (
            /* Affihage du logo dans le coin & d'une image en banner */
            React.createElement(React.Fragment, null,
                React.createElement(CardMedia, { sx: styles.banner, component: "img", image: banner }),
                React.createElement(CardMedia, { sx: styles.miniLogo, component: "img", image: logo, alt: alt })))),
            React.createElement(Stack, { sx: styles.contentContainer },
                variant !== 'LogoOnly' && (React.createElement(React.Fragment, null,
                    React.createElement(Typography, { sx: styles.categoryLabel, variant: "body-small-semibold" }, category),
                    React.createElement(Typography, { sx: styles.contentLabel, variant: "body-default-semibold" }, content))),
                React.createElement(ClubRTagCashbackLabel, { type: cashBack.type, value: cashBack.value, hasBoost: cashBack.boost, hasMulti: cashBack.multi })))));
};
